/* src/app/shared/components/header/header.component.scss */
.header-spacer {
  flex: 1;
}
.user {
  font-family: sans-serif;
  font-size: 0.6rem;
  font-weight: 600;
  padding-right: 20px;
  letter-spacing: 0.1rem;
}
.header-row {
  background-image: url("./media/midpage-banner-blue-lines-new.png");
}
.logout {
  width: 120px;
}
.status-row {
  height: 20px;
}
.auth-status {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02rem;
  padding: 4px 10px;
  border-radius: 999px;
}
.logged-in {
  color: white;
  background: rgba(255, 255, 255, 0.12);
}
.auth-required {
  color: #ffebee;
  background: rgba(183, 28, 28, 0.35);
  border: 1px solid rgba(255, 205, 210, 0.35);
}
.sign-in-button {
  min-width: 120px;
  color: #ffffff !important;
  background-color: #c62828 !important;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.08rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.sign-in-button:hover {
  background-color: #b71c1c !important;
}
.sign-in-button:focus {
  outline: 2px solid rgba(255, 255, 255, 0.55);
  outline-offset: 2px;
}
/*# sourceMappingURL=header.component.css.map */
